import { render, staticRenderFns } from "./Bookshelf.vue?vue&type=template&id=6689550d&scoped=true&"
import script from "./Bookshelf.vue?vue&type=script&lang=js&"
export * from "./Bookshelf.vue?vue&type=script&lang=js&"
import style0 from "./Bookshelf.vue?vue&type=style&index=0&id=6689550d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689550d",
  null
  
)

export default component.exports